import { Link, useRouterState } from '@tanstack/react-router';
import { useUser, SignInButton, UserButton } from '@clerk/clerk-react';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

export function Navigation() {
  const { isSignedIn, isLoaded } = useUser();
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/tournaments', label: 'Tournaments' },
    { to: '/register', label: 'Register' },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center space-x-2">
            <span className="font-heading text-xl font-bold text-primary">
              Tourney.dev
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={cn(
                  'text-sm font-medium transition-colors hover:text-foreground',
                  currentPath === link.to
                    ? 'text-foreground'
                    : 'text-muted-foreground'
                )}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-4">
          {isLoaded && (
            <>
              {isSignedIn ? (
                <div className="flex items-center gap-4">
                  <Link
                    to="/account"
                    className={cn(
                      'text-sm font-medium transition-colors hover:text-foreground hidden sm:block',
                      currentPath === '/account'
                        ? 'text-foreground'
                        : 'text-muted-foreground'
                    )}
                  >
                    My Account
                  </Link>
                  <UserButton afterSignOutUrl="/" />
                </div>
              ) : (
                <SignInButton mode="modal">
                  <Button variant="outline" size="sm">
                    Sign In
                  </Button>
                </SignInButton>
              )}
            </>
          )}
        </div>
      </div>
    </header>
  );
}
